export default __webpack_public_path__ + "static/media/cloud-rain.f970a65e.svg";